import { MapEditor } from "../../../components/maps/MapEditor.js";
import { useEnsuredMap } from "../useEnsuredMap.js";
import { useChapterContext } from "./useChapterContext.js";
import { ErrorState, useT } from "@mmm/ui";
/** The chapter's single mind map. */
export function ChapterMapTab() {
  const { subject, chapter } = useChapterContext();
  const { map, error, retry } = useEnsuredMap(subject, chapter.id, chapter.title);
  const t = useT();

  if (error) return <ErrorState title={t("maps.loadFailed")} onRetry={retry} />;
  if (!map) return null;
  return <MapEditor key={map.id} mindMapId={map.id} />;
}
